import { RootState } from '../../store';

export const getTeams = (state: RootState): any => state?.teams?.teams;

export const getAuthorizedTeams = (state: RootState): any =>
  state?.teams?.authorizedTeams;

export const getTeamsHash = (state: RootState): any => state?.teams?.teamsHash;
